/**
 * Copyright © Veeam Software Group GmbH.
 */

import { VboObjectTypeRepresentation as VboObjectTypeRepresentationModel } from '@veeam-vspc/models/web-controllers';

export type VboObjectTypeRepresentation = VboObjectTypeRepresentationModel;
export const VboObjectTypeRepresentation = VboObjectTypeRepresentationModel;
